import { useLocation } from 'react-router-dom';

export default function usePathName() {
  const location = useLocation();
  const path = location.pathname;

  return path;
}
